import axios from 'lib/axios'

export interface BrainIdealProfile {
  FI: number
  BI: number
  BD: number
  FD: number
}

const saveBrainIdealProfile = async (processId: number, idealProfile: BrainIdealProfile) => {
  const body = {
    process_id: processId,
    ideal_profile: idealProfile,
  }
  const brainIdealProfile = await axios
    .post(`/betesa_result/brain_ideal_profile/`, body)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return { ok: false, message: error.message }
    })

  return brainIdealProfile
}

export default saveBrainIdealProfile
